export default "__VITE_ASSET__C0h9Z3K___"